import { get } from 'lodash'

export const getStartTimer = state => get(state, 'common.startTimer')

export const getResetTimer = state => get(state, 'common.reset')
